var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4974 29.3332C9.1336 29.3332 3.16406 23.3636 3.16406 15.9998C3.16406 8.63604 9.1336 2.6665 16.4974 2.6665C23.8611 2.6665 29.8307 8.63604 29.8307 15.9998C29.8307 23.3636 23.8611 29.3332 16.4974 29.3332ZM15.1675 21.3332L24.5957 11.9051L22.7101 10.0195L15.1675 17.562L11.3963 13.7906L9.51072 15.6764L15.1675 21.3332Z",
    fill: "#3BA358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.8eb07edf3fde20df4dd4249d43682cbc.svg";
export { ForwardRef as ReactComponent };